<template>
    <div class="mb-2">
        <div class="fw-bold fs-6 text-uppercase" :class="titleClass">{{ title }}</div>
        <div class="mt-n1" :class="descriptionClass">{{ description }}</div>
    </div>
</template>

<script setup lang="ts">
const { title, description, titleClass = [], descriptionClass = ["text-muted"] } = defineProps<{
    title: string,
    description: string,
    titleClass?: string[],
    descriptionClass?: string[]
}>()
</script>

<style scoped>

</style>
